import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="8"
    height="10"
    viewBox="0 0 8 10"
    fill="currentColor"
    stroke="transparent"
    strokeWidth="0.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M0.0800781 0.00585938H3.56641C5.01107 0.00585938 6.04102 0.220052 6.65625 0.648438C7.27148 1.07682 7.5791 1.69206 7.5791 2.49414C7.5791 2.93164 7.49935 3.30306 7.33984 3.6084C7.1849 3.91374 6.98665 4.15527 6.74512 4.33301C6.50814 4.51074 6.26432 4.63151 6.01367 4.69531V4.76367C6.28711 4.83203 6.55827 4.94596 6.82715 5.10547C7.10059 5.26042 7.32617 5.49512 7.50391 5.80957C7.6862 6.11947 7.77734 6.54102 7.77734 7.07422C7.77734 7.68034 7.6224 8.20215 7.3125 8.63965C7.00716 9.07715 6.56966 9.41439 6 9.65137C5.43034 9.88379 4.75358 10 3.96973 10H0.0800781V0.00585938ZM2.78027 3.84082H3.59375C4.04036 3.84082 4.35482 3.74967 4.53711 3.56738C4.7194 3.38053 4.81055 3.15495 4.81055 2.89062C4.81055 2.61719 4.70573 2.40983 4.49609 2.26855C4.29102 2.12272 3.97201 2.0498 3.53906 2.0498H2.78027V3.84082ZM2.78027 5.81641V7.91504H3.73047C4.19987 7.91504 4.52799 7.81478 4.71484 7.61426C4.90169 7.40918 4.99512 7.15397 4.99512 6.84863C4.99512 6.6709 4.9541 6.50456 4.87207 6.34961C4.7946 6.1901 4.66016 6.0625 4.46875 5.9668C4.27734 5.86654 4.01302 5.81641 3.67578 5.81641H2.78027Z" />
  </svg>
);
